import React from 'react';

import { Checkbox, Grid, Input, ListItemText, MenuItem, Select, Typography } from '@material-ui/core';

export default ({ onTypeChange, selectedType, typeList }) => {
  const getSelectedLabel = (selected) => {
    if (!selected.length) return 'No type';
    if (selected.length === 1) return selected[0];
    if (selected.length === Object.keys(typeList).length) return 'All types';
    return `${selected[0]} + ${selected.length - 1}`;
  };

  return (
    <Grid container item alignItems="center" xs={12} sm={4}>
      <Typography>Type: &nbsp;</Typography>
      <Select
        multiple
        displayEmpty
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        value={selectedType}
        onChange={onTypeChange}
        input={<Input disableUnderline />}
        renderValue={getSelectedLabel}
        MenuProps={{
          anchorOrigin: {
            horizontal: 'left',
            vertical: 'bottom',
          },
          getContentAnchorEl: null,
        }}>
        {['Images', '3D Models', 'Videos', 'Studies', 'Documents'].map((name) => {
          const isChecked = selectedType.includes(name);
          return (
            <MenuItem key={name} value={name}>
              <Checkbox checked={isChecked} color="primary" />
              <ListItemText primary={name} />
            </MenuItem>
          );
        })}
      </Select>
    </Grid>
  );
};
